import React, { Component } from "react";
import { Divider } from "antd";
import { getRedirectQueryParams } from "../../Constants/Utilities";
import { AppStorageKeys, DeviceManagePaths } from "../../Constants/Constants";
import { BreadCrumbs } from "../Common/BreadCrumbs";
import SessionStorage from "../../Constants/SessionStorage";

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);

export default class ListGroups extends Component {
  constructor(props) {
    super(props);
    const { protocol, hostname } = window.location;
    this.deviceManageUrl =
      protocol + "//" + hostname + ":" + ENV_VARS_FE.DEVICE_MANAGE_PORT;
  }

  render() {
    const { parentBread, onParentActionClick, serviceProviderRecord } =
      this.props;
    const redirectUrl = getRedirectQueryParams({
      path: DeviceManagePaths.group,
      part: serviceProviderRecord.name,
      prov: serviceProviderRecord.providerId,
    });

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Groups`)}
            onParentActionClick={onParentActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Service Provider: {serviceProviderRecord?.name}</label>
        </div>
        <iframe
          className="new-frame"
          title="Group Management"
          src={this.deviceManageUrl + "/login?" + redirectUrl}
        />
      </div>
    );
  }
}
